<template>
  <myhead @next="next" @lookmore="more">{{$route.meta.title}}</myhead>
  <div class="android item">
    <div class="title">安卓</div>
    <div class="content bor">
      <img src="@/assets/img/android.png" class="mr20" alt="">
      <van-button type="success" @click="goDownload('android')">安卓版<img src="@/assets/img/icon73.png"
          class="setting-list__arricon pointer width20px" /></van-button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
const router = useRouter()
const goDownload = (val) => {
  if (val == 'android') {
   router.push("/download/detail")
  }
}
</script>

<style lang="scss" scoped>
.item{
  padding:0 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #888;
  .title{
    margin: 20px 0;
    font-size: 26px;
    font-weight: bold;
  }
}
</style>